import Axios, { AxiosRequestConfig, AxiosResponse, Method } from 'axios';
import { successSnack, warningSnack } from 'main_consts';
import { IRptInOutDailyQry } from 'view/projects/RptInOutDailyQry/type';
import { IapiReponse, IblobDownload, IsnackBarRsp } from './main_type';

Axios.defaults.withCredentials = true;
const apiDomain = `${window.location.protocol}//${window.location.host}`;

const instance = Axios.create({
  baseURL: apiDomain,
  headers: { 'Content-Type': 'application/json' },
  timeout: 120000,
});

let isRedirectingToLogin = false;

export const callMethod = (
  method: Method,
  url: string,
  data = {},
  config: AxiosRequestConfig = {}
): Promise<AxiosResponse<unknown>> => {
  switch (method.toLowerCase()) {
    case 'post':
      return instance.post(url, data, config);
    case 'get':
      return instance.get(url, {
        params: data,
        ...config,
        paramsSerializer: (params) => {
          // Sample implementation of query string building
          let result = '';
          Object.keys(params).forEach((key) => {
            result += `${key}=${encodeURIComponent(params[key])}&`;
          });
          return result.substr(0, result.length - 1);
        },
      });
    case 'delete':
      return instance.delete(url, { params: data });
    case 'put':
      return instance.put(url, data);
    case 'patch':
      return instance.patch(url, data);
    default:
      // console.log(`未知的 method: ${method}`);
      return instance.get(url, { params: data });
  }
};

export const snackBarRsp: IsnackBarRsp = (
  enqueueSnackbar,
  response,
  successNoShow = false
): boolean => {
  if (!response || response.data.msg === '伺服器發生未知錯誤，請稍後再試') {
    enqueueSnackbar('系統忙碌中，請稍後再試...');
    return false;
  }
  const { data } = response;
  // 0: 成功
  if (successNoShow && data.status === 0) {
    return true;
  }
  if (data.msg) {
    enqueueSnackbar(data.msg, data.status === 0 ? successSnack : warningSnack);
  }
  return true;
};

instance.interceptors.request.use(
  (config) => {
    // console.log(config);
    return config;
  },
  (error) => {
    // console.log('error => ', error);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    const { status } = response.data ?? {};
    const currentPath = window.location.pathname || '';
    const guestBypassPages = ['/InvoiceQry', '/CarRegisterMtn'];
    const isGuestBypassPage = guestBypassPages.some(
      (pagePath) =>
        currentPath === pagePath || currentPath.startsWith(`${pagePath}/`)
    );
    const isApwehuPage =
      currentPath === '/APWEHU' || currentPath.startsWith('/APWEHU/');
    const requestUrl = response.config?.url || '';
    const logoutRequests = ['api/login/logout', 'api/logout/success'];
    const isLogoutRequest = logoutRequests.some((url) =>
      requestUrl.includes(url)
    );

    switch (status) {
      case 4: {
        // 登出請求由 logoutClick 自行導向 login，不顯示未登入提示
        if (isLogoutRequest) {
          return response;
        }

        // 免登入頁面（含 query string）不做未登入導回，避免被強制跳轉 login
        if (isGuestBypassPage) {
          return response;
        }

        // APWEHU 直接導向登入頁，不顯示未登入警告
        if (isApwehuPage) {
          if (!isRedirectingToLogin) {
            isRedirectingToLogin = true;
            window.location.href = '/login';
          }
          return response;
        }

        // 尚未登入或登入逾時, 導向自建登入頁 (不再導至外部SSO登入頁)
        const isLoginPage = window.location.pathname.toLowerCase() === '/login';
        if (!isLoginPage && !isRedirectingToLogin) {
          isRedirectingToLogin = true;
          // eslint-disable-next-line no-alert
          alert('您尚未登入或登入狀態已失效，請重新登入。');
          window.location.href = '/login';
        }
        break;
      }

      default:
        break;
    }

    return response;
  },
  (error) => {
    switch (error.response?.status) {
      case 400:
        if (error.response?.data.data) {
          // eslint-disable-next-line no-alert
          alert(error.response?.data.data);
        }
        break;
      case 404:
        // eslint-disable-next-line no-alert
        // alert(`系統代碼：${error.response?.status}，請重新連線。`);
        // window.parent.location.reload();
        break;
      case 410:
        // eslint-disable-next-line no-alert
        alert('找不到該稅單檔案，請重新查詢。');
        // window.parent.location.reload();
        break;
      default:
        // eslint-disable-next-line no-alert
        alert(`系統代碼：${error.response?.status || '0'}，請重新連線。`);
        window.parent.location.reload();
        break;
    }
    // window.location.reload();
    if (!window.navigator.onLine) {
      // console.log('網路異常，請重新連線');
    }
    return Promise.reject(error);
  }
);

// #region API區

// #region 【Login 登入】取得menu、User資料
export const getLoginInfo = (): Promise<IapiReponse> => {
  return callMethod('get', 'api/loginInfo') as Promise<IapiReponse>;
};

/** 帳號密碼登入 */
export const login = (
  userId: string,
  password: string
): Promise<IapiReponse> => {
  return callMethod('post', 'api/login/authenticate', {
    userId,
    password,
  }) as Promise<IapiReponse>;
};

/** 登出 */
export const logout = (): Promise<IapiReponse> => {
  return callMethod('post', 'api/login/logout') as Promise<IapiReponse>;
};
// #endregion

// #region logoutOut 舊saab 登出】
// export const logoutOut = (para = {}): Promise<IapiReponse> => {
//   return callMethod('get', `api/logout/success`, {
//     ...para,
//   }) as Promise<IapiReponse>;
// };
// #region 【QRCode訪客登入】取得menu、User資料
export const getLoginInfoGuest = (): Promise<IapiReponse> => {
  return callMethod('get', 'api/qrcode/loginInfo') as Promise<IapiReponse>;
};
// #endregion
// #region 【QRCode訪客登入】取得menu、User資料
export const getLoginInfoGuest2 = (): Promise<IapiReponse> => {
  return callMethod('get', 'api/carRegister/loginInfo') as Promise<IapiReponse>;
};
// #endregion

// #region 【查詢】
export const getSearch = (apiName: string, para = {}): Promise<IapiReponse> => {
  return callMethod(
    'get',
    `api/${apiName}/search`,
    para
  ) as Promise<IapiReponse>;
};
/** 分頁SEARCH */
export const getSearchByPage = (
  apiName: string,
  para = {}
): Promise<IapiReponse> => {
  return callMethod(
    'get',
    `api/${apiName}/searchByPage`,
    para
  ) as Promise<IapiReponse>;
};
export const postSearch = (
  apiName: string,
  para = {}
): Promise<IapiReponse> => {
  return callMethod(
    'post',
    `api/${apiName}/search`,
    para
  ) as Promise<IapiReponse>;
};
// #endregion

// #region 【確認】
export const confirm = (apiName: string, para = {}): Promise<IapiReponse> => {
  return callMethod(
    'post',
    `api/${apiName}/confirm`,
    para
  ) as Promise<IapiReponse>;
};
// #endregion

// #region 【刪除】
export const deleteItem = (
  apiName: string,
  para = {}
): Promise<IapiReponse> => {
  return callMethod(
    'post',
    `api/${apiName}/deleteItem`,
    para
  ) as Promise<IapiReponse>;
};
// #endregion

// #region 【圖片下載】】
export const exportPicture = (
  apiName: string,
  para = {}
): Promise<IapiReponse> => {
  return callMethod(
    'post',
    `api/${apiName}/exportPicture`,
    para
  ) as Promise<IapiReponse>;
};
// #endregion

// #region 【匯入】
export const upload = (apiName: string, para = {}): Promise<IapiReponse> => {
  return callMethod(
    'post',
    `api/${apiName}/upload`,
    para
  ) as Promise<IapiReponse>;
};
// #endregion

// #region 【Excel範例下載】
export const getSample = (apiName: string, para = {}): Promise<IapiReponse> => {
  return callMethod('post', `api/${apiName}/getSample`, para, {
    responseType: 'blob',
  }) as Promise<IapiReponse>;
};
// #endregion

// #region 【Excel下載】
export const getExcel = (apiName: string, para = {}): Promise<IapiReponse> => {
  return callMethod('get', `api/${apiName}/exportExcelFile`, para, {
    responseType: 'blob',
  }) as Promise<IapiReponse>;
};
export const blobDownload: IblobDownload = (
  response,
  enqueueSnackbar,
  fileName
): void => {
  if (!response.headers['content-disposition']) {
    if (response.headers.body) {
      try {
        const res = JSON.parse(decodeURIComponent(response.headers.body));
        enqueueSnackbar(res.msg);
      } catch (e) {
        // console.log(e)
        enqueueSnackbar('系統忙碌中，請稍後再試...');
      }
    }
    return;
  }

  // const fileName = response.headers['content-disposition']
  //   .split('=')[1]
  //   .replace(/"/g, '');
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(new Blob([response.data]));
  link.setAttribute('download', fileName); // or any other extension
  link.dispatchEvent(new MouseEvent('click'));
  // document.body.appendChild(link);
  // link.click();
};
// #endregion

// #region 【共通API(common)】

//  記帳代號取得業者名稱
export const getFindExpressNameByChkCode1AndWarehouse = (
  para = {}
): Promise<IapiReponse> => {
  return callMethod('get', `api/common/findExpressNameByChkCode1AndWarehouse`, {
    ...para,
  }) as Promise<IapiReponse>;
};

// 根據使用者別檢核快遞倉站是否存在於卸存地基本資料檔
export const getIsWarehouseExist = (para = {}): Promise<IapiReponse> => {
  return callMethod('get', `api/common/isWarehouseExist`, {
    ...para,
  }) as Promise<IapiReponse>;
};

//  取得快遞倉站清單
export const getWarehouse = (): Promise<IapiReponse> => {
  return callMethod(
    'get',
    `api/common/findDropDownWarehouse`
  ) as Promise<IapiReponse>;
};
// #endregion

// #region 【分提單查詢】

// 取得主號列表
export const getFindMawbNoList = (para: {
  declType: '1' | '2';
  hawbNo: string;
}): Promise<IapiReponse> => {
  return callMethod(
    'get',
    `api/hawbQry/findMawbNoList`,
    para
  ) as Promise<IapiReponse>;
};
// #endregion

// #region 【使用者功能權限設定作業】

// 取得ehuFunctionChk使用者資訊
export const getfindEhuFunctionChk = (): Promise<IapiReponse> => {
  return callMethod(
    'get',
    `api/common/findEhuFunctionChk`
  ) as Promise<IapiReponse>;
};

// 取得使用者資訊
export const getFindUserByAspUserId = (
  apiName: string,
  para = {}
): Promise<IapiReponse> => {
  return callMethod(
    'get',
    `api/${apiName}/findUserByAspUserId`,
    para
  ) as Promise<IapiReponse>;
};

//  取得身份別下拉選單
export const getFindDropDownUserType = (
  apiName: string
): Promise<IapiReponse> => {
  return callMethod(
    'get',
    `api/${apiName}/findDropDownUserType`
  ) as Promise<IapiReponse>;
};

// #endregion

//   #region 取得下拉選單
export const getFindDropDown = (
  apiName: string,
  funcName: string,
  para = {}
): Promise<IapiReponse> => {
  return callMethod('get', `api/${apiName}/${funcName}`, {
    ...para,
  }) as Promise<IapiReponse>;
};

// #endregion

//  #region 取得下拉選單
export const postFindDropDown = (
  apiName: string,
  funcName: string,
  para = {}
): Promise<IapiReponse> => {
  return callMethod('post', `api/${apiName}/${funcName}`, {
    ...para,
  }) as Promise<IapiReponse>;
};

// #endregion

//  #region 取得貨物儲位設定維護明細查詢
export const getGoodsPositionMtnFindDetail = (
  para = {}
): Promise<IapiReponse> => {
  return callMethod('post', `api/goodsPositionMtn/findDetail`, {
    ...para,
  }) as Promise<IapiReponse>;
};

// #endregion

// #region 取得快遞業者/承攬業者下拉選單

export const getfindDropDownExpresssName = (
  para = {}
): Promise<IapiReponse> => {
  return callMethod('get', `api/common/findDropDownExpresssName`, {
    ...para,
  }) as Promise<IapiReponse>;
};

// #endregion

// #region  取得動態櫃號下拉選單

export const getfindDropDownContainerNo = (para = {}): Promise<IapiReponse> => {
  return callMethod('get', `api/common/findDropDownContainerNo`, {
    ...para,
  }) as Promise<IapiReponse>;
};

// #endregion

// #region 取得動態封條

export const getfindSealNoInfo = (para = {}): Promise<IapiReponse> => {
  return callMethod('get', `api/ctgdsStatusMtn/findSealNoInfo`, {
    ...para,
  }) as Promise<IapiReponse>;
};

// #endregion
// #region 取得櫃動庫登錄帳號

export const getfindImctUserId = (para = {}): Promise<IapiReponse> => {
  return callMethod('get', `api/ctgdsStatusMtn/findAspCustomerId`, {
    ...para,
  }) as Promise<IapiReponse>;
};

// #endregion

// #region 取得外部URL

export const findOutRUL = (para = {}): Promise<IapiReponse> => {
  return callMethod('get', `api/common/findOutRUL`, {
    ...para,
  }) as Promise<IapiReponse>;
};

// #endregion

// // #region /logout

// export const logout = (para = {}): Promise<IapiReponse> => {
//   return callMethod('get', `api/logout/success`, {
//     ...para,
//   }) as Promise<IapiReponse>;
// };

// // #endregion

// #region 進出倉交接表

/** 超過特定筆數，該檔案轉移到下載專區 */
export const getSaveExcelFile = (
  para: IRptInOutDailyQry,
  check: boolean
): Promise<IapiReponse> => {
  return callMethod('get', `api/rptInOutDailyQry/saveExcelFile`, {
    ...para,
    check,
  }) as Promise<IapiReponse>;
};

// #endregion

// #region 下載專區

/** 查詢excel檔案清單 */
export const getExcelFileList = (): Promise<IapiReponse> => {
  return callMethod(
    'get',
    `api/rptDownload/getExcelFileList`
  ) as Promise<IapiReponse>;
};

/** 下載Excel */
export const getDownloadExcelFile = (
  fileName: string
): Promise<IapiReponse> => {
  return callMethod(
    'get',
    `api/rptDownload/downloadExcelFile`,
    {
      fileName,
    },
    {
      responseType: 'blob',
      timeout: 180000,
    }
  ) as Promise<IapiReponse>;
};

/** 新下載方式 */
export const getDownloadExcelFileNew = (fileName: string) => {
  const url = `/api/rptDownload/downloadExcelFile?fileName=${encodeURIComponent(
    fileName
  )}`;

  // 讓瀏覽器直接發送 GET 請求，伺服器回傳檔案時會自動觸發下載
  window.open(url, '_blank');
};

/** 刪除excel */
export const getDeleteExcelFile = (fileName: string): Promise<IapiReponse> => {
  return callMethod('get', `api/rptDownload/deleteExcelFile`, {
    fileName,
  }) as Promise<IapiReponse>;
};

// #endregion

// #region 稅單查詢

export const postSaveDutyFile = (para = {}): Promise<IapiReponse> => {
  return callMethod(
    'post',
    `api/dutyNoQryDld/saveDutyFile`,
    para
  ) as Promise<IapiReponse>;
};

export interface IGetDownloadDutyFileParam {
  qryType: '1' | '2' | '3' | '4' | '5' | '6';
  sortType: '0' | '1' | '2' | '3' | '4' | '5' | '6';

  ban: string;
  defDutyCode: string;
  declNo: string;

  importStartDate: string;
  importEndDate: string;
  gcoStartDate: string;
  gcoEndDate: string;
  mawbNo: string;
  chkCode1: string;
  warehouse: string;
  boxNo: string;
  customId: string;
  mawbNoAndHawbNoList: { mawbNo: string; hawbNo: string }[];
  dutyNoList: string[];
  downloadDutyNoList: string[];
  downloadType: '0' | '1';
  defDutyMark1: string;
  defDutyMark2: string;
  fileNameType?: string;
}

export const postDownloadDutyFile = (
  para: IGetDownloadDutyFileParam
): Promise<AxiosResponse> => {
  return callMethod('post', `api/dutyNoQryDld/downloadDutyFile`, para, {
    responseType: 'blob',
  }) as Promise<AxiosResponse>;
};

export const postAsynchronousDownloadDutyFile = (
  para: IGetDownloadDutyFileParam
): Promise<AxiosResponse> => {
  return callMethod(
    'post',
    `api/dutyNoQryDld/asynchronousDownloadDutyFile`,
    para
  ) as Promise<AxiosResponse>;
};

// #endregion

// misInOutStatQry 進出倉貨量統計表

export const postAsynchronousDownloadInOutStatFile = (
  apiName: string,
  para = {}
): Promise<AxiosResponse> => {
  return callMethod(
    'post',
    `api/${apiName}/asynchronousDownloadInOutStatFile`,
    para
  ) as Promise<AxiosResponse>;
};

// #region 稅單收據資料設定

export interface IGetDownloadExpTaxRecpSet {
  qryType: '1' | '2' | '3' | '4';
  chkCode3: string;
  importStartDate: string;
  importEndDate: string;
  gcoStartDate: string;
  gcoEndDate: string;
  mawbNo: string;
  mawbNoAndHawbNoList: { mawbNo: string; hawbNo: string }[];
  dutyNoList: string[];
}

export const postExportTmpExcelFile = (para: any): Promise<AxiosResponse> => {
  return callMethod('post', `api/expTaxRecpSet/exportTmpExcelFile`, para, {
    responseType: 'blob',
  }) as Promise<AxiosResponse>;
};
export const postExcelExpTaxRecpSet = (
  para: IGetDownloadExpTaxRecpSet
): Promise<AxiosResponse> => {
  return callMethod('post', `api/expTaxRecpSet/exportExcelFile`, para, {
    responseType: 'blob',
  }) as Promise<AxiosResponse>;
};

export const postUploadExcelExpTaxRecpSet = (
  apiName: string,
  para = {}
): Promise<IapiReponse> => {
  return callMethod('post', `api/${apiName}/uploadExcelExpTaxRecpSet`, para, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }) as Promise<IapiReponse>;
};

export const postSaveExpTaxRecpSet = (
  apiName: string,
  para = {}
): Promise<IapiReponse> => {
  return callMethod(
    'post',
    `api/${apiName}/saveExpTaxRecpSet`,
    para
  ) as Promise<IapiReponse>;
};

// #endregion

// #region post下載Excel

export const postExcel = (
  apiName: string,
  para = {}
): Promise<AxiosResponse> => {
  return callMethod('post', `api/${apiName}/exportExcelFile`, para, {
    responseType: 'blob',
  }) as Promise<AxiosResponse>;
};

// #endregion
// #region post下載PDF

export const postPDF = (apiName: string, para = {}): Promise<AxiosResponse> => {
  return callMethod('post', `api/${apiName}/exportPdfFile`, para, {
    responseType: 'blob',
  }) as Promise<AxiosResponse>;
};

// #endregion

// #region post留櫃設定

export const postLockerSetting = (
  apiName: string,
  para = {}
): Promise<IapiReponse> => {
  return callMethod(
    'post',
    `api/${apiName}/lockerSetting`,
    para
  ) as Promise<IapiReponse>;
};
// #endregion

// #region post取消留櫃
export const postUnLockerSetting = (
  apiName: string,
  para = {}
): Promise<IapiReponse> => {
  return callMethod(
    'post',
    `api/${apiName}/unlockerSetting`,
    para
  ) as Promise<IapiReponse>;
};
// #endregion

// #region post取得到櫃日期

export const postUpdateEtaDateCyNote = (
  apiName: string,
  para = {}
): Promise<IapiReponse> => {
  return callMethod(
    'post',
    `api/${apiName}/updateEtaDateCyNote`,
    para
  ) as Promise<IapiReponse>;
};
// #endregion

// #region post取得儲位圖檔

export const getImgSrc = (apiName: string, para = {}): Promise<IapiReponse> => {
  return callMethod(
    'post',
    `api/${apiName}/getImgSrc`,
    para
  ) as Promise<IapiReponse>;
};
// #endregion
export const postChangePwd = (para = {}): Promise<IapiReponse> => {
  return callMethod(
    'post',
    'api/common/changePwd',
    para
  ) as Promise<IapiReponse>;
};

// #region post取得QRCode資料

export const getQRCodeSearch = (
  apiName: string,
  para = {}
): Promise<IapiReponse> => {
  return callMethod(
    'post',
    `api/${apiName}/qrCodeSearch`,
    para
  ) as Promise<IapiReponse>;
};
// #endregion

// #region post取得資料

export const postApiAndFunctionName = (
  apiName: string,
  functionName: string,
  para = {}
): Promise<IapiReponse> => {
  return callMethod(
    'post',
    `api/${apiName}/${functionName}`,
    para
  ) as Promise<IapiReponse>;
};
// #endregion

// #region post下載Excel

export const postExcelAndFunctionName = (
  apiName: string,
  functionName: string,
  para = {}
): Promise<AxiosResponse> => {
  return callMethod('post', `api/${apiName}/${functionName}`, para, {
    responseType: 'blob',
  }) as Promise<AxiosResponse>;
};

// #endregion
